import { useState, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export function Input({ label, id, className = '', type, ...props }: InputProps) {
  const [isRevealed, setIsRevealed] = useState(false);
  const isPassword = type === 'password';

  return (
    <div className="font-manuscript flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm font-medium text-manuscript-ink-soft">
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={isPassword && isRevealed ? 'text' : type}
          className={`w-full rounded-sm border border-manuscript-line-strong bg-paper-50 px-3.5 py-2.5 text-sm text-manuscript-ink outline-none transition-colors placeholder:text-manuscript-ink-faint focus:border-seal-500 focus-visible:ring-2 focus-visible:ring-seal-500/50 focus-visible:ring-offset-1 ${isPassword ? 'pr-10' : ''} ${className}`}
          {...props}
        />
        {isPassword && <PasswordVisibilityToggle isRevealed={isRevealed} onToggle={() => setIsRevealed((prev) => !prev)} />}
      </div>
    </div>
  );
}

export function PasswordVisibilityToggle({
  isRevealed,
  onToggle,
}: {
  isRevealed: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="absolute inset-y-0 right-0 flex items-center px-3 text-manuscript-ink-faint hover:text-manuscript-ink"
      aria-label={isRevealed ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
      tabIndex={-1}
    >
      {isRevealed ? <EyeOffIcon /> : <EyeIcon />}
    </button>
  );
}

function EyeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path
        d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.3 20.3 0 0 1 5.06-5.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a20.3 20.3 0 0 1-4.06 5.06M14.12 14.12a3 3 0 1 1-4.24-4.24"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 1l22 22" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
